import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import { GlobalQuestionService } from '../../services/global-question.service';
import { QuestionFlowSessionQuery } from '../state/question-flow-session.query';
import {getParam} from '../question-helper';

@Component({
    selector: 'app-question-timepicker',
    templateUrl: './question-timepicker.component.html',
    styleUrls: ['./question-timepicker.component.scss'],
    standalone: false
})
export class QuestionTimepickerComponent implements OnInit {

  @Input() hour = '';
  @Input() minute = '';
  @Input() ampm: any = [];
  @Input() disabledButton = true;
  @Input() question: Question;
  @Input() showLabel = false;
  @Input() noShadow = false;
  @Output() questionAnswer = new EventEmitter<any>();
  skipped = false;
  showSkip = false;
  parameter: any;
  sessionDetails: any;
  maxMinute = 59;
  maxHour = 12;
  minHour = 0;
  minMinute = 0;
  constructor(public globalQuestionService: GlobalQuestionService, private questionFlowSessionQuery: QuestionFlowSessionQuery) {
    this.sessionDetails = this.questionFlowSessionQuery.getValue();
  }

  ngOnInit(): void {
    try {
      this.parameter = JSON.parse(this.question.parameter);
    } catch (e) { }
    if (getParam(this.parameter, 'show_skip')?.value === '1') {
      this.showSkip = true;
    }

    this.ampm = [
      {id: 'am', value: 'AM', checked: false},
      {id: 'pm', value: 'PM', checked: false}
    ];

    if (this.question?.answer) {
      const times = this.question.answer.split(':');
      const timeOfDay = times[1].split(' ')[1];
      if (timeOfDay) {
        const itemIndex = this.ampm.findIndex(item => item.value === timeOfDay);
        if (itemIndex > -1) {
          this.ampm.forEach(i => {
            i.checked = false;
          });
          this.ampm[itemIndex].checked = true;
        }
      }
      this.hour = times[0];
      this.minute = times[1].split(' ')[0];
    }
    const parameters = new Map<string, string>();
    parameters.set('session_id', this.sessionDetails?.session_id);
    this.globalQuestionService.runCommandNew(`getClaimsTimeRange`, parameters).subscribe(resp => {

      const timedRange = JSON.parse(resp[0]?.time_range);
      if (timedRange) {

        const min = timedRange[0]?.parameter === 'min_time' ? timedRange[0]?.value : '';
        const max = timedRange[1]?.parameter === 'max_time' ? timedRange[1]?.value : '';

        this.maxHour = max ? parseInt(max.split(':')[0]) : 12;
        this.minHour = min ? parseInt(min.split(':')[0]) : 0;
        this.maxMinute = max ? parseInt(max.split(':')[1]) : 59;
        this.minMinute = min ? parseInt(min.split(':')[1]) : 0;
        
        // Determine AM/PM availability based on min and max times
        const isMinTimeAM = this.isAM(min);
        const isMaxTimeAM = this.isAM(max);
   
        const am = this.ampm.find((i: any) => i.id === 'am');
        const pm = this.ampm.find((i: any) => i.id === 'pm');

        if (isMinTimeAM && isMaxTimeAM) {
          Object.assign(am, {checked: true, disabled: false});
          Object.assign(pm, {checked: false, disabled: true});
        } else if (!isMinTimeAM && !isMaxTimeAM) {
          Object.assign(am, {checked: true, disabled: false});
          Object.assign(pm, {checked: false, disabled: true});
        } else {
          Object.assign(am, {checked: false, disabled: false});
          Object.assign(pm, {checked: false, disabled: false});
        }
      }
    }, error => {
      console.log(error);
    });
  }
  isAM(timeString: string): boolean {
    if (!timeString) return false;

    // Extract hour from "09:00" format
    const hourNum = parseInt(timeString.split(':')[0]);

    // Check if hour is between 0-11 (AM in 24-hour format)
    return hourNum >= 0 && hourNum < 12;
  }
  onBlur(event: any): void {
    const value = event?.target?.value;
    const min = event?.target?.min;
    const max = event?.target?.max;
    const name = event?.target?.name;

    if (value) {
      if (+value > min && +value <= max) {
        const val = ('0' + +value).slice(-2);
        if (name === 'hour') {
          this.hour = val;
        } else {
          this.minute = val;
        }
      } else {
        if (+value > max) {
          const val = ('0' + max).slice(-2);
          if (name === 'hour') {
            this.hour = val;
          } else {
            this.minute = val;
          }
        } else {
          const val = ('0' + min).slice(-2);
          if (name === 'hour') {
            this.hour = val;
          } else {
            this.minute = val;
          }
        }
      }
      this.submitTime();
    }
  }

  onChange(item: any): void {
    const itemIndex = this.ampm.findIndex((i: any) => i.id === item.id);
    if (itemIndex > -1) {
      this.ampm.forEach(i => {
        i.checked = false;
      });
      if (this.ampm[itemIndex]) {
        this.ampm[itemIndex].checked = !this.ampm[itemIndex].checked;
      }
      this.submitTime();
    }
  }
  onSkipChange(): void {
    if (this.skipped) {
      this.question.answer = 'skipped';
    } else {
      this.question.answer = '';
    }
    this.questionAnswer.emit(this.question);
  }
  submitTime(): void {
    const selectedTimeOfDay = this.ampm.find((i: any) => i.checked === true);
    if (this.hour && this.minute && selectedTimeOfDay) {
      const time = this.hour + ':' + this.minute + ' ' + selectedTimeOfDay.value;
      if (this.question) {
        this.question.answer = time;
        this.questionAnswer.emit(this.question);
      } else {
        this.questionAnswer.emit(time);
      }
    }
  }
}
